// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  isMockEnabled: false, // You have to switch this, when your real back-end is done
  Authorization: "Base64 YWRtaW46YWRtaW5AMzIx",
  // Production
  // apiBaseUrl: "https://recsllc.net/recsapi/api/v1",
  // plaidApiBaseUrl: "https://recsllc.net/recsapi/api/v2",

  // Development
  // apiBaseUrl: window.location.protocol + "//recs.smartpoint.in/api/v1",
  apiBaseUrl: "http://65.1.73.181:3005/api/v1",
  //apiBaseUrl: "http://localhost:3005/api/v1",
  // plaidApiBaseUrl: window.location.protocol + "//recs.smartpoint.in/api/v2",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
